/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateSkillRequestBody,
  CreateSkillRequestBody$Outbound,
  CreateSkillRequestBody$outboundSchema,
} from "../components/createskillrequestbody.js";

export type CreateSkillSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateSkillSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateSkillSecurity = {
  option1?: CreateSkillSecurityOption1 | undefined;
  option2?: CreateSkillSecurityOption2 | undefined;
};

export type CreateSkillRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createSkillRequestBody: CreateSkillRequestBody;
};

/** @internal */
export type CreateSkillSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateSkillSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateSkillSecurityOption1$Outbound,
  CreateSkillSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createSkillSecurityOption1ToJSON(
  createSkillSecurityOption1: CreateSkillSecurityOption1,
): string {
  return JSON.stringify(
    CreateSkillSecurityOption1$outboundSchema.parse(createSkillSecurityOption1),
  );
}

/** @internal */
export type CreateSkillSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateSkillSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateSkillSecurityOption2$Outbound,
  CreateSkillSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createSkillSecurityOption2ToJSON(
  createSkillSecurityOption2: CreateSkillSecurityOption2,
): string {
  return JSON.stringify(
    CreateSkillSecurityOption2$outboundSchema.parse(createSkillSecurityOption2),
  );
}

/** @internal */
export type CreateSkillSecurity$Outbound = {
  Option1?: CreateSkillSecurityOption1$Outbound | undefined;
  Option2?: CreateSkillSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateSkillSecurity$outboundSchema: z.ZodMiniType<
  CreateSkillSecurity$Outbound,
  CreateSkillSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateSkillSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateSkillSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createSkillSecurityToJSON(
  createSkillSecurity: CreateSkillSecurity,
): string {
  return JSON.stringify(
    CreateSkillSecurity$outboundSchema.parse(createSkillSecurity),
  );
}

/** @internal */
export type CreateSkillRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateSkillRequestBody: CreateSkillRequestBody$Outbound;
};

/** @internal */
export const CreateSkillRequest$outboundSchema: z.ZodMiniType<
  CreateSkillRequest$Outbound,
  CreateSkillRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createSkillRequestBody: CreateSkillRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createSkillRequestBody: "CreateSkillRequestBody",
    });
  }),
);

export function createSkillRequestToJSON(
  createSkillRequest: CreateSkillRequest,
): string {
  return JSON.stringify(
    CreateSkillRequest$outboundSchema.parse(createSkillRequest),
  );
}
